import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import store from '../store'
import {getToken} from '@/utils/auth'
import {Loading} from 'element-ui';
// 创建axios实例
const service = axios.create({
  baseURL: process.env.NODE_ENV == "development" ? process.env.BASE_API : process.env.BASE_API, // api的base_url
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

var loading = null;
// request拦截器
service.interceptors.request.use(config => {
  // if (store.getters.token) {
  //   config.headers['Authorization'] = "Bearer " + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  var sessionId = localStorage.getItem('sessionId');
  if(sessionId){
    config.headers['userSession']=sessionId;
  }
  loading = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  return config
}, error => {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error)
});

// respone拦截器
service.interceptors.response.use(
  res => {
    loading.close();
    // console.log(res.data);
    if (res.data.body) {
      // 3333:Token 过期了;
      if (res.data.body.resultCode == '9999' || res.data.body.resultCode == '3333') {
        MessageBox.alert('登录信息已过期，请重新登录', {
          confirmButtonText: '确定',
          center: true,
          showClose: false
        }).then(() => {
          store.dispatch('clear').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
    }


    return res.data;
  },
  error => {
    console.log('err' + error)// for debug
    loading.close();
    if (error.response) {
      switch (error.response.status) {
        case 403:
          Message({
            message: '拒绝访问(403)',
            type: 'error',
            duration: 5 * 1000
          });
          break;
        case 429:
          Message({
            message: '您请求太过频繁,您稍后再试(429)',
            type: 'error',
            duration: 5 * 1000
          });
          break;
        case 500:
          Message({
            message: '服务器错误(500)',
            type: 'error',
            duration: 5 * 1000
          });
          break;
        case 502:
          Message({
            message: '网络错误(502)',
            type: 'error',
            duration: 5 * 1000
          });
          break;
        case 404:
          Message({
            message: '请求出错(404)',
            type: 'error',
            duration: 5 * 1000
          });
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js